import { EMBED_TYPE } from './experiences';

/**
 * Check if experience has embed type
 *
 * @param {string} type - Current experience type
 * @returns {boolean} - True if experience has embed type, false otherwise
 */
export const isEmbedExperience = type => type === EMBED_TYPE;
